import React, { Component } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { StoryElement } from "@quintype/components";
import { SliderPrevIcon } from "../../basic/icons/slider-prev-btn";
import { SliderNextIcon } from "../../basic/icons/slider-next-btn";
import { LightBox } from "../lightbox";
import Carousel from "../../glidejs";

import "./slider.m.css";

class GlideSliderBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carouselIndex: 1,
      showPopup: false
    };
    this.togglePopup = this.togglePopup.bind(this);
  }
  togglePopup() {
    this.setState({
      showPopup: !this.state.showPopup
    });
  }
  render() {
    const next = () => {
      this.state.carouselIndex !== this.props.totalItems
        ? this.setState({ carouselIndex: this.state.carouselIndex + 1 })
        : this.setState({ carouselIndex: 1 });
    };

    const previous = () => {
      this.state.carouselIndex === 1
        ? this.setState({ carouselIndex: this.props.totalItems })
        : this.setState({ carouselIndex: this.state.carouselIndex - 1 });
    };

    return (
      <div styleName={this.props.publisherAttributes.lang === "ur" ? "ur-slider" : "en-slider"}>
        <Carousel
          carouselName={`${this.props.story.slug}`}
          className="story-slider"
          options={{
            type: "carousel",
            perView: 1
          }}
          totalItems={this.props.totalItems}
          renderCenterLeftControls={({ previousSlide }) => (
            <button onClick={previous} styleName="slider-btn slider-btn-left">
              <SliderPrevIcon />
            </button>
          )}
          renderCenterRightControls={({ nextSlide }) => (
            <button onClick={next} styleName="slider-btn slider-btn-right">
              <SliderNextIcon />
            </button>
          )}
        >
          {[
            <div
              styleName="image-element"
              onClick={this.togglePopup}
              key={this.props.getImagesFromCards[this.state.carouselIndex - 1].id}
            >
              <StoryElement
                element={this.props.getImagesFromCards[this.state.carouselIndex - 1]}
                story={this.props.story}
                key={this.props.getImagesFromCards[this.state.carouselIndex - 1].id}
              />
            </div>
          ]}
        </Carousel>
        {this.state.showPopup ? (
          <LightBox
            element={this.props.getImagesFromCards[this.state.carouselIndex - 1]}
            closePopup={this.togglePopup}
          />
        ) : null}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], "")
  };
}

GlideSliderBase.propTypes = {
  totalItems: PropTypes.string,
  publisherAttributes: PropTypes.object,
  getImagesFromCards: PropTypes.func,
  story: PropTypes.object
};

export const GlideSlider = connect(
  mapStateToProps,
  null
)(GlideSliderBase);
